<template>
    <div :id="Year + '_' + Month + '_Orders'" class="SalesCategory">

    </div>
    <div :id="Year + '_' + Month + '_Cost'" class="SalesCategory">

    </div>
    <template v-for="distributor in DistributorNames" :key="distributor">
        <div :id="distributor+'_'+Year+'_'+Month+'_Orders'" class="SalesCategory">

        </div>
        <div :id="distributor+'_'+Year+'_'+Month+'_Sales'" class="SalesCategory">
            
        </div>
        <div :id="distributor+'_'+Year+'_'+Month+'_Profit'" class="SalesCategory">
            
        </div>
    </template>
    <div :id="Year + '_' + Month + '_Samples'" class="SalesCategory">

    </div>
    <div :id="Year + '_' + Month + '_Loss'" class="SalesCategory">

    </div>
    <div :id="Year + '_' + Month + '_TotalShipments'" class="SalesCategory">

    </div>
    <div :id="Year + '_' + Month + '_InventoryQuantity'" class="SalesCategory">

    </div>
    <div :id="Year + '_' + Month + '_InventoryValue'" class="SalesCategory">

    </div>
</template>

<script>
export default{
    props:{
        Year:Number,
        Month:Number,
        DistributorNames:Array,
    }
}
</script>